module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8019.de4b9ae8.png";